@switch (displayType) {
  @case (CurrencyUnitDisplayType.Symbol) {
    {{ currencySymbol }}
  }

  @case (CurrencyUnitDisplayType.Code) {
    {{ currencyCode }}
  }

  @case (CurrencyUnitDisplayType.Icon) {
    @if (currencyIcon) {
      <img [height]="iconSize" [width]="iconSize" [src]="currencyIcon" lazy="loading" />
    }
  }

  @default {}
}
